import * as React from 'react';
import { RichTextSectionFieldsFragment } from 'types/generated';
import RichText from './RichText';
import clsx from 'clsx';

type Props = {
  data: RichTextSectionFieldsFragment;
};

const RichTextSection = ({ data }: Props) => {
  const collection = data.richTextsCollection;

  return (
    collection && (
      <>
        {collection?.items && (
          <div
            className={`${clsx({
              'grid lg:grid-flow-col': collection.items.length > 1,
            })}`}
          >
            {collection.items.map(function (object, i) {
              {
                return (
                  object?.richText &&
                  object?.textAlignment && (
                    <div
                      className={`grid gap-16 py-24 ${clsx({
                        'lg:px-12': collection.items.length > 1,
                      })}`}
                    >
                      <RichText
                        data={object.richText}
                        textAlignment={object.textAlignment}
                        isFilloutStandardEmbed={!!object?.isFilloutStandardEmbed}
                        key={i}
                      />
                    </div>
                  )
                );
              }
            })}
          </div>
        )}
      </>
    )
  );
};
export default RichTextSection;
